export default "__VITE_ASSET__Cihsl8_s__"